module.exports = __webpack_public_path__ + "static/assets/8221d1ce26995074b5cb5c10896e0392.gif";